import React, { useState } from "react";
import IconClose from "../Resources/svg/Icons/IconClose";
import ModalFiltering from "./FormElements/ModalFiltering";
import Button from "./FormElements/Button";
import { useHistory } from "react-router-dom";

const ModalWhatchListV2 = ({
  watchlist,
  setWatchlist,
  blackList,
  yellowList,
  formType,
  actionAsured,
  actionContratant
}) => {
  const history = useHistory();
  const [loadingClick, setLoadingClick] = useState(false);

  const handleWatch = () => {
    setLoadingClick(true);

    setTimeout(() => {
      setWatchlist(false);
      setLoadingClick(false);
      if(yellowList) {
        if(formType === "asured") actionAsured();
        if(formType === "contratant") actionContratant();
      }
      if(blackList) history.push("/productos");
    }, 500);
  };

  const watchlistMessage = () => {
    const messages = {
      blackList: `En esta oportunidad, no podremos atender la solicitud de 
      registro/cotización del cliente, debido a medidas de gestión 
      internas; por lo que no podrás continuar con el flujo de venta`,
      yellowList: `Los datos registrados serán revisados por nuestras áreas internas.
      Por favor, completa toda la información del cliente para que puedan
      culminar con su evaluación y luego, continues con el proceso de
      venta`
  };
  
  return blackList ? messages.blackList : yellowList ? messages.yellowList : "";
  }

  return (
    <ModalFiltering
      className={`modal-result is-midle watchlistv2 ${
        watchlist && "is-open"
      }`}
    >
      <div
        className="modal-filtering__close"
        onClick={() => setWatchlist(false)}
      >
        <IconClose />
      </div>
      <h2 className="modal-result__title">Validación del documento</h2>
      <div className="modal-result__desc">
        <p>{watchlistMessage()}</p>
      </div>
      <div className="actions">
        <Button
          type="submit"
          className={`${loadingClick ? "is-loading" : ""} actions__continue`}
          onClick={() => handleWatch(false)}
        >
          Aceptar
        </Button>
      </div>
    </ModalFiltering>
  );
};

export default ModalWhatchListV2;
